import React, { useState, useEffect } from "react";
import axios from "axios";
import './ConsignmentForm.css';

const ManifestForm = () => {
  const [manifestId, setManifestId] = useState('');
  const [dateTime, setDateTime] = useState(new Date().toISOString().slice(0, 16));
  const [forwardedThrough, setForwardedThrough] = useState("Road");
  const [driverName, setDriverName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [lockNumber, setLockNumber] = useState("");
  const [destinationHub, setDestinationHub] = useState("");
  const [destinationBranch, setDestinationBranch] = useState("");
  const [consignments, setConsignments] = useState([]);
  const [selectedConsignments, setSelectedConsignments] = useState([]);
  const [hubs, setHubs] = useState([]);
  const [branches, setBranches] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    // Fetch all hubs from the backend
    const fetchHubs = async () => {
      try {
        const response = await axios.get('https://kartikenterprisesindia.co.in/api/users/hub/');
        setHubs(response.data); // Set hubs in state
      } catch (err) {
        setError('Failed to fetch hubs');
      }
    };

    fetchHubs();
  }, []);

  const handleHubChange = async (hubId) => {
    setDestinationHub(hubId);
    setDestinationBranch(''); // Reset branch dropdown

    // Fetch branches for the selected hub
    try {
      const response = await axios.get(`https://kartikenterprisesindia.co.in/api/users/branch?hub=${hubId}`);
      setBranches(response.data);
    } catch (err) {
      setError('Failed to fetch branches for the selected hub');
    }
  };

  useEffect(() => {

    const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("auth_token="));
  const userId = token
    ? JSON.parse(atob(token.split("=")[1].split(".")[1])).userId
    : null;
    
    const fetchManifestId = async () => {
      try {
        const response = await axios.get("https://kartikenterprisesindia.co.in/api/manifests/nextid");
        setManifestId(response.data.manifestId);
      } catch (error) {
        alert("Failed to fetch manifest ID.");
      }
    };

    const fetchConsignments = async () => {
      try {
        // Pass userId as a query parameter
        const response = await axios.get(
          `https://kartikenterprisesindia.co.in/api/consignments/pending/?userId=${userId}`
        );
        setConsignments(response.data);
      } catch (error) {
        console.error("Failed to fetch consignments:", error);
        alert("Failed to fetch consignments.");
      }
    };

    fetchManifestId();
    fetchConsignments();
  }, []);

  const toggleConsignmentSelection = (consignmentId) => {
    if (selectedConsignments.includes(consignmentId)) {
      setSelectedConsignments(selectedConsignments.filter((id) => id !== consignmentId));
    } else {
      setSelectedConsignments([...selectedConsignments, consignmentId]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const token = document.cookie.split('; ').find(row => row.startsWith('auth_token='));
    const userId = token ? JSON.parse(atob(token.split('=')[1].split('.')[1])).userId : null;

    const manifestData = {
      userId,
      manifestId,
      dateTime,
      forwardedThrough,
      driverName,
      mobileNumber,
      vehicleNumber,
      lockNumber,
      destinationHub,
      destinationBranch,
      consignment: selectedConsignments, // Use selectedConsignment IDs
    };

    try {
      await axios.post("https://kartikenterprisesindia.co.in/api/manifests", manifestData);
      alert("Manifest created successfully!");
    } catch (error) {
      alert("Error creating manifest.");
    }
  };

  return (
    <form className="consignment-form" onSubmit={handleSubmit}>
      <h2>Manifest Form</h2>
      {/* Manifest details */}
      <div className="row">
        <div className="column30">
          <label>Manifest ID</label>
          <input type="text" value={manifestId} readOnly />
        </div>
        <div className="column30">
          <label>Date & Time</label>
          <input
            type="datetime-local"
            value={dateTime}
            onChange={(e) => setDateTime(e.target.value)}
          />
        </div>
        <div className="column30">
          <label>Forwarded Through</label>
          <select value={forwardedThrough} onChange={(e) => setForwardedThrough(e.target.value)}>
            <option value="Road">Road</option>
            <option value="Air">Air</option>
            <option value="Sea">Sea</option>
          </select>
        </div>
      </div>

      <div className="row">
        <div className="column30">
          <label>Driver Name</label>
          <input
            type="text"
            placeholder="Driver Name"
            value={driverName}
            onChange={(e) => setDriverName(e.target.value)}
          />
        </div>
        <div className="column30">
          <label>Mobile Number</label>
          <input
            type="text"
            placeholder="Mobile Number"
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value)}
          />
        </div>
        <div className="column30">
          <label>Vehicle Number</label>
          <input
            type="text"
            placeholder="Vehicle Number"
            value={vehicleNumber}
            onChange={(e) => setVehicleNumber(e.target.value)}
          />
        </div>
      </div>

      <div className="row">
        <div className="column30">
          <label>Lock Number</label>
          <input
            type="text"
            placeholder="Lock Number"
            value={lockNumber}
            onChange={(e) => setLockNumber(e.target.value)}
          />
        </div>
        <div className="column30">
          <label>Destination Hub</label>
          <select
            value={destinationHub}
            onChange={(e) => handleHubChange(e.target.value)} required>

            <option value="">Select Hub</option>
            {hubs.map((hubItem) => (
              <option key={hubItem._id} value={hubItem._id}>
                {hubItem.code} 
              </option>
            ))}
          </select>
        </div>
        <div className="column30">
          <label>Destination Branch</label>
          <select value={destinationBranch} onChange={(e) => setDestinationBranch(e.target.value)} required>
            <option value="">Select Branch</option>
            {branches.map((branch) => (
              <option key={branch._id} value={branch._id}>
                {branch.code}
              </option>
            ))}
          </select>
        </div>
      </div>

      <h3>Available Consignments</h3>
      <div className="row" style={{fontSize:'11px'}}>
        {consignments.map((consignment) => (
          <div className="column30">
         <button
          type="button"
          key={consignment._id}
          className={`consignment-button ${
            selectedConsignments.includes(consignment._id) ? "selected" : ""
          }`}
          onClick={() => toggleConsignmentSelection(consignment._id)}
        >
          <b>{consignment.consignmentNumber}</b> -{consignment.sender.city} to {consignment.receiver.city}
          {selectedConsignments.includes(consignment._id) && (
            <span className="checkmark">✔</span>
          )}
        </button>
          </div>
        ))}
      </div>

      <button type="submit" style={{backgroundColor:'blue'}}>Create Manifest</button>
    </form>
  );
};

export default ManifestForm;
